import { Host, h } from "@stencil/core";
import { Jodit } from "jodit";
import { decodeHtml } from "../../utilities/stringUtilities";
export class DnnRichtext {
    constructor() {
        /** Sets the value of the content of the editor. */
        this.value = "";
        /** Allows registering your own plugins.
         * The callback will be called with the editor instance as the only argument durig initialization.
         * All other behavior needs to be implemented in the plugin itself using editor.on("eventname").
         * See https://xdsoft.net/jodit/examples/plugin/custom_plugin.html for an example.
         * Creating a plugin does NOT automatically add it to the toolbar, you need to do that yourself in 'options' or 'customizeOptions',
         * See https://xdsoft.net/jodit/examples/toolbar/custom_button.html for an example.
         */
        this.plugins = [];
        this.focused = false;
        this.dnnDefaultOptions = Object.assign(Object.assign({}, Jodit.defaultOptions), { useSplitMode: true });
    }
    watchValueChanged(newValue) {
        if (this.editor !== null && this.editor !== undefined) {
            this.editor.value = decodeHtml(newValue);
        }
        this.setFormValue();
    }
    componentDidLoad() {
        var _a;
        var mergedOptions = Object.assign(Object.assign(Object.assign({}, this.dnnDefaultOptions), this.options), { shadowRoot: this.host.shadowRoot });
        if (this.customizeOptions != undefined) {
            mergedOptions = this.customizeOptions(mergedOptions);
        }
        this.plugins.forEach(plugin => Jodit.plugins.add(plugin.name, plugin.callback));
        this.editor = Jodit.make(this.textArea, mergedOptions);
        this.editor.value = decodeHtml((_a = this.value) !== null && _a !== void 0 ? _a : "");
        this.setFormValue();
        this.editor.e.on('input', () => this.valueInput.emit(this.editor.value));
        this.editor.e.on("focus", () => this.focused = true);
        this.editor.e.on("blur", () => {
            this.focused = false;
            this.valueChange.emit(this.editor.value);
            this.setFormValue();
        });
    }
    formResetCallback() {
        this.editor.value = decodeHtml(this.value || "");
        this.internals.setValidity({});
        this.setFormValue();
    }
    setFormValue() {
        if (this.name != undefined && this.name.length > 0) {
            var data = new FormData();
            data.append(this.name, this.editor.value);
            this.internals.setFormValue(data);
        }
    }
    render() {
        return (h(Host, { key: '5e8d974a84cc144e30a57ea57fbfb452d6d8893e', tabIndex: this.focused ? -1 : 0, onFocus: () => {
                this.focused = true;
                this.editor.focus();
            }, onBlur: () => this.focused = false }, h("textarea", { key: '4bbd4d9d93da53ce4809af6dd07425b4f6501d15', ref: el => this.textArea = el, onFocus: () => this.focused = true, onBlur: () => this.focused = false })));
    }
    static get is() { return "dnn-richtext"; }
    static get formAssociated() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-richtext.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-richtext.css"]
        };
    }
    static get properties() {
        return {
            "options": {
                "type": "unknown",
                "attribute": "options",
                "mutable": false,
                "complexType": {
                    "original": "Config",
                    "resolved": "Config | undefined",
                    "references": {
                        "Config": {
                            "location": "import",
                            "path": "jodit/types/config",
                            "id": "../../node_modules/jodit/types/config.d.ts::Config"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optional configuration for Jodit, see https://xdsoft.net/jodit/docs/classes/config.Config.html\nThis will be merged with the default options and passed to the editor.\nIf you prefer to not have to pass a full config object,\nyou can use 'customizeOptions' to modify the options before initializing the editor\ninstead of providing all options here."
                },
                "getter": false,
                "setter": false
            },
            "value": {
                "type": "string",
                "attribute": "value",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the value of the content of the editor."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "attribute": "name",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Name of the field when used in a form."
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "plugins": {
                "type": "unknown",
                "attribute": "plugins",
                "mutable": false,
                "complexType": {
                    "original": "{name: string, callback: (editor: Jodit) => void}[]",
                    "resolved": "{ name: string; callback: (editor: Jodit) => void; }[]",
                    "references": {
                        "Jodit": {
                            "location": "import",
                            "path": "jodit",
                            "id": "../../node_modules/jodit/types/index.d.ts::Jodit"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Allows registering your own plugins.\nThe callback will be called with the editor instance as the only argument durig initialization.\nAll other behavior needs to be implemented in the plugin itself using editor.on(\"eventname\").\nSee https://xdsoft.net/jodit/examples/plugin/custom_plugin.html for an example.\nCreating a plugin does NOT automatically add it to the toolbar, you need to do that yourself in 'options' or 'customizeOptions',\nSee https://xdsoft.net/jodit/examples/toolbar/custom_button.html for an example."
                },
                "getter": false,
                "setter": false,
                "defaultValue": "[]"
            },
            "customizeOptions": {
                "type": "unknown",
                "attribute": "customize-options",
                "mutable": false,
                "complexType": {
                    "original": "(options: Config) => Config",
                    "resolved": "((options: Config) => Config) | undefined",
                    "references": {
                        "Config": {
                            "location": "import",
                            "path": "jodit/types/config",
                            "id": "../../node_modules/jodit/types/config.d.ts::Config"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Customize the options before initializing the editor, will have all the default options merged with 'options' if passed.\nThis is called last after merging default options with your custom 'options' and just before initializing the editor."
                },
                "getter": false,
                "setter": false
            }
        };
    }
    static get states() {
        return {
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "valueChange",
                "name": "valueChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the value changed."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "valueInput",
                "name": "valueInput",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires during value input."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
    static get watchers() {
        return [{
                "propName": "value",
                "methodName": "watchValueChanged"
            }];
    }
    static get attachInternalsMemberName() { return "internals"; }
}
//# sourceMappingURL=dnn-richtext.js.map
